module.exports = __webpack_public_path__ + "img/11.def3f8a7.png";